'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabItem = exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Tab = require('../Tab');

var _Tab2 = _interopRequireDefault(_Tab);

var _TabList = require('./TabList.css');

var _TabList2 = _interopRequireDefault(_TabList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * This component passes the changeTab callback from Tab to Tabs
 */
var TabList = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(TabList, _Component);

  function TabList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TabList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TabList.__proto__ || (0, _getPrototypeOf2.default)(TabList)).call.apply(_ref, [this].concat(args))), _this), _this.renderChildren = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          changeTab = _this$props.changeTab;


      return children.map(function (child, index) {
        if (index === _this.props.selected) {
          return (0, _react.cloneElement)(child, {
            key: index,
            index: index,
            className: (0, _classnames2.default)(child.props.className, _TabList2.default.tab),
            isSelected: true,
            changeTab: changeTab
          });
        }

        return (0, _react.cloneElement)(child, {
          key: index,
          index: index,
          className: (0, _classnames2.default)(child.props.className, _TabList2.default.tab),
          changeTab: changeTab
        });
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TabList, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement(
        'ul',
        { className: (0, _classnames2.default)(className, _TabList2.default.root) },
        this.renderChildren()
      );
    }
  }]);
  return TabList;
}(_react.Component), _class.Tab = _Tab2.default, _class.propTypes = {
  /** This prop designates which tab is selected based off its index */
  selected: _react.PropTypes.number,
  /** This is the callback which is fired upon the onclick event */
  changeTab: _react.PropTypes.func,
  className: _react.PropTypes.string,
  children: _react.PropTypes.node.isRequired
}, _class.defaultProps = {
  children: [],
  selected: 0
}, _temp2);
exports.default = TabList;
exports.TabItem = _Tab2.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseTabs/TabList/TabList.jsx
// module id = 1616
// module chunks = 0